var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permiteDevolver)?_c('b-button',{staticClass:"ml-2",attrs:{"variant":"danger"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDevolver()}}},[_c('span',[_c('i',{staticClass:"fa fa-reply-all"}),_vm._v(" Devolver ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }